


















































































import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

import moment from 'moment';

@Component({
    components: {

    }
}) export default class Notice extends Mixins(VueHoduCommon) {

    hodu_notice_list : any[] = [];

    mounted() : void {
        this.getHoduNoticeList();
    }

    /**
     * 호두 공지사항 리스트 조회
     */
    getHoduNoticeList() : void {
        const vue = this;

        this.hodu_api_call(`api/v1/hodu/notice?current_date=${moment(new Date()).utc().format()}`, 'get')
            .then((response) => {
                console.log(response);
                vue.hodu_notice_list.splice(0, vue.hodu_notice_list.length);
                vue.hodu_notice_list = vue.hodu_notice_list.concat(response.data.data.hodu_notice_list);
            })
            .catch((e) => {

            });
    }

    /**
     * 공지사항 조회로 이동
     */
    goNoticeDetail(noti_uid : string) : void {
        this.$router.push(`/notice/${noti_uid}`).catch((e) => {});
    }

}

